import * as React from 'react'
export const SvgTruck = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={40} height={40} {...props}>
    <path d="M17.874 26a4.002 4.002 0 01-7.748 0H9.047V12.022H24v1.999L28 14l3 5 .023 7.028-1.153-.01A4.002 4.002 0 0122.126 26h-4.252zM23 16v4h6v-1l-2-3h-4zm-9 11a2 2 0 100-4 2 2 0 000 4zm12 0a2 2 0 100-4 2 2 0 000 4z" />
  </svg>
)
export default SvgTruck
